import { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getSharedWaiver } from "store/digital-waiver"

export const useSharedWaiverData = (id) => {
  const dispatch = useDispatch()
  const { waiver, loading } = useSelector((store) => store.digitalWaiver)

  const status = useMemo(() => {
    return Array.isArray(waiver?.waiver_submissions) && waiver.waiver_submissions.length > 0 
      ? waiver.waiver_submissions[0]?.status 
      : undefined
  }, [waiver])

  const waiverSubmissionId = useMemo(() => {
    return Array.isArray(waiver?.waiver_submissions) && waiver.waiver_submissions.length > 0 
      ? waiver.waiver_submissions[0]?.id 
      : undefined
  }, [waiver])

  useEffect(() => {
    if (id) {
      dispatch(getSharedWaiver(id))
    }
  }, [id, dispatch])

  return {
    waiver,
    loading,
    status,
    waiverSubmissionId
  }
}
